import { z } from '@/utils/zod'

export const OrganizationDomainSchema = z.object({
    type: z.enum(['email']),
    domain: z.string().min(1),
    dnsRecords: z.array(z.record(z.string(), z.any())),
    verified: z.boolean(),
    registeredAt: z.isoDateOnly,
    sendingAddress: z.email().or(z.literal('')).nullable(),
    providerId: z.string().min(1).nullable(),
    operation: z
        .object({
            id: z.uuid(),
            revision: z.number().int().nonnegative().max(Number.MAX_SAFE_INTEGER),
            kind: z.enum(['setup', 'verify', 'remove']),
            phase: z.enum(['inspect', 'create', 'configure', 'remove']),
            state: z.enum(['pending', 'running', 'failed', 'review']),
            requestedAt: z.isoDateTime,
            nextAttemptAt: z.isoDateTime.nullable(),
            leaseId: z.uuid().nullable(),
            attempts: z.number().int().nonnegative(),
            error: z.string().nullable(),
        })
        .nullable(),
})

export type OrganizationDomain = z.infer<typeof OrganizationDomainSchema>
